const sizes=[[20,30,49],[30,30,65],[30,40,85],[30,50,95],[40,40,95],[40,50,98],[40,70,115],[50,50,125],[50,60,135],[50,70,145],[50,100,185],[70,100,240],[80,100,275],[90,120,305]];

/* V15.10 — cursor de zoom mai mare și contrastant, inclusiv pe iPhone. */
(function enhanceZoomSlider(){
  const style=document.createElement('style');
  style.id='tabloria-zoom-slider-v1510';
  style.textContent=`
    #tabloria-configurator #zoom {
      -webkit-appearance:none !important; appearance:none !important;
      display:block; width:100%; height:12px !important;
      margin:22px 0 26px !important; padding:0 !important;
      background:#ffe0cf !important; border:2px solid #ff641f !important;
      border-radius:999px !important; cursor:pointer;
      touch-action:pan-x;
    }
    #tabloria-configurator #zoom::-webkit-slider-thumb {
      -webkit-appearance:none !important; appearance:none !important;
      width:32px !important; height:32px !important;
      background:#ff641f !important; border:4px solid #fff !important;
      border-radius:50% !important;
      box-shadow:0 0 0 2px #c7470b,0 3px 9px rgba(0,0,0,.25) !important;
      cursor:grab;
    }
    #tabloria-configurator #zoom::-moz-range-thumb {
      width:25px !important; height:25px !important;
      background:#ff641f !important; border:4px solid #fff !important;
      border-radius:50% !important;
      box-shadow:0 0 0 2px #c7470b,0 3px 9px rgba(0,0,0,.25) !important;
      cursor:grab;
    }
    #tabloria-configurator #zoom:focus-visible {outline:3px solid #252b30 !important;outline-offset:5px !important;}
  `;
  document.head.appendChild(style);
})();

const $=id=>document.getElementById(id);let shopifyVariants=new Map();let shopifyReady=false;let selected=0,landscape=false,detail=false,viewMode="auto",original=null,originalURL=null,crop={zoom:1,x:0,y:0},working={zoom:1,x:0,y:0},drag=null,previewURL=null;

/* V15.43 — Google Merchant Center: preselectare dimensiune din ?size=30x40.
   Nu intervine în încărcarea pozei, Upload-Lift sau fluxul de comandă.
   Transferul din Asistentul de perete își păstrează prioritatea proprie. */
(function tabloriaSelectSizeFromURL(){
  try {
    const requested=new URLSearchParams(window.location.search).get('size');
    if(!requested)return;
    const match=requested.trim().toLowerCase().match(/^(\d{2,3})\s*[x×]\s*(\d{2,3})(?:\s*cm)?$/);
    if(!match)return;
    const key=`${Number(match[1])}x${Number(match[2])}`;
    const index=sizes.findIndex(([w,h])=>`${w}x${h}`===key);
    if(index!==-1)selected=index;
  } catch(error) {
    console.warn('Tabloria: dimensiunea din URL nu a putut fi citită.',error);
  }
})();


/* V15.7 — ordinea pașilor: dimensiune, orientare, fotografie.

   Mutăm elementele existente, fără a recrea inputul și fără a pierde integrarea Upload-Lift. */

(function arrangeConfiguratorSteps(){

  const root=document.getElementById('tabloria-configurator');

  if(!root)return;

  const sizesField=document.getElementById('sizes')?.closest('.field');

  const orientationField=document.getElementById('vertical')?.closest('.field');

  const photoInput=document.getElementById('file');

  const photoField=photoInput?.closest('.field');

  const editButton=document.getElementById('edit');

  if(!sizesField||!orientationField||!photoField||!editButton)return;

  const rightPanel=sizesField.closest('.panel');

  if(!rightPanel)return;

  const sizeLabel=sizesField.querySelector('label');

  const orientationLabel=orientationField.querySelector('label');

  const photoLabel=photoField.querySelector('label');

  if(sizeLabel)sizeLabel.textContent='1. Selectează dimensiunea dorită (cm)';

  if(orientationLabel)orientationLabel.textContent='2. Orientarea tabloului';

  if(photoLabel)photoLabel.textContent='3. Încarcă poza ta';

  orientationField.insertAdjacentElement('afterend',photoField);

  photoField.insertAdjacentElement('afterend',editButton);

})();

/* V15.8: pe mobil simularea apare după încărcare/editare și înainte de preț și coș.

   Pe desktop rămâne layoutul original în două coloane. */

(function responsiveSimulationOrder(){

  const root=document.getElementById('tabloria-configurator');

  const layout=root?.querySelector('.layout');

  const simulation=layout?.querySelector('.panel:first-child');

  const rightPanel=document.getElementById('sizes')?.closest('.panel');

  const editButton=document.getElementById('edit');

  if(!layout||!simulation||!rightPanel||!editButton)return;

  const anchor=document.createComment('Tabloria: original simulation position');

  layout.insertBefore(anchor,simulation);

  const media=window.matchMedia('(max-width: 950px)');

  function relocate(){

    if(media.matches){

      if(simulation.parentElement!==rightPanel)editButton.insertAdjacentElement('afterend',simulation);

    }else{

      if(simulation.parentElement!==layout)layout.insertBefore(simulation,anchor.nextSibling);

    }

    if(typeof render==='function')requestAnimationFrame(render);

  }

  const style=document.createElement('style');

  style.textContent=`@media(max-width:950px){

    #tabloria-configurator .layout>.panel:nth-child(2)>.panel,

    #tabloria-configurator .layout>.panel>.panel{margin:16px 0 18px;padding:0;border:0;border-radius:0;box-shadow:none;background:transparent}

    #tabloria-configurator .layout>.panel>.panel .tabs{margin-top:10px}

  }`;

  root.appendChild(style);

  media.addEventListener?.('change',relocate);

  relocate();

})();

function dims(){const [w,h,p]=sizes[selected];return {w:landscape?h:w,h:landscape?w:h,p}}

function render(){const {w,h,p}=dims();const isSmall=[0,1,2].includes(selected);const photo3d=viewMode==='photo3d';const hands=!photo3d&&!detail&&(viewMode==='hands'||(viewMode==='auto'&&isSmall));$('handsScene').hidden=!hands;$('scene').hidden=hands||photo3d;const photoCard=$('tabloria-photo3d-card');if(photoCard)photoCard.hidden=!photo3d||!original;const photoTab=$('tabloriaPhoto3DTab');if(photoTab)photoTab.classList.toggle('active',photo3d);$('handsTab').classList.toggle('active',hands);$('roomTab').classList.toggle('active',!hands&&!detail&&!photo3d);$('detailTab').classList.toggle('active',detail&&!photo3d);const ha=$('handsArt');const hs=$('handsScene');const scale=hs.getBoundingClientRect().width||hs.parentElement.getBoundingClientRect().width||600;

/* V15: ancorare pe palme, scala uniforma pentru toate cele 14 dimensiuni.

   Dimensiunile mai mari cresc in sus, inclusiv peste fata modelului. */

const handPixelsPerCm=scale*0.00707;

ha.style.width=(w*handPixelsPerCm)+'px';ha.style.height=(h*handPixelsPerCm)+'px';$('handsLabel').textContent=`${w} × ${h} cm · model 168 cm`; $('sizes').innerHTML=sizes.map(([a,b,pr],i)=>{const variant=shopifyVariants.get(`${a}x${b}`);const displayPrice=variant?(variant.price/100).toLocaleString('ro-RO',{maximumFractionDigits:2}):pr;return `<button class="size ${i===selected?'active':''}" data-index="${i}">${a} × ${b}<br><small>${displayPrice} lei</small></button>`}).join('');document.querySelectorAll('.size').forEach(el=>el.onclick=()=>{selected=Number(el.dataset.index);tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;viewMode='auto';detail=false;tabloria3D.active=false;crop={zoom:1,x:0,y:0};updateCropPreview();render()});const key=`${sizes[selected][0]}x${sizes[selected][1]}`;const v=shopifyVariants.get(key);$('price').textContent=(v?(v.price/100).toLocaleString('ro-RO',{maximumFractionDigits:2}):p)+' lei';$('chosen').textContent=`Dimensiune: ${w} × ${h} cm`;$('vertical').classList.toggle('active',!landscape);$('horizontal').classList.toggle('active',landscape);$('scene').classList.toggle('detail',detail);const scene=$('scene');let px;if(detail){px=Math.min(scene.clientWidth*.8/w,scene.clientHeight*.8/h)}else{px=scene.clientWidth/990*3.02}const art=$('art');art.style.width=(w*px)+'px';art.style.height=(h*px)+'px';syncTabloria3D();if(tabloria3D.ready)paintTabloriaMini3D();}

/* V15.27 — încadrări cu rezervă reală de pânză de 3 cm pe toate laturile. */
function tabloriaWrapMinZoom(){
  if(!original)return 1;
  const {w,h}=dims(),iw=original.naturalWidth,ih=original.naturalHeight;
  const cover=Math.max(w/iw,h/ih);
  return Math.max(1,(w+6)/(iw*cover),(h+6)/(ih*cover));
}
function tabloriaConstrainCrop(c){
  if(!original)return c;
  const {w,h}=dims(),iw=original.naturalWidth,ih=original.naturalHeight;
  const z=tabloriaWrapMinZoom();c.zoom=Math.max(z,Number(c.zoom)||1);
  const base=Math.max(w/iw,h/ih)*c.zoom;
  const extraX=(iw*base-w)/2-3,extraY=(ih*base-h)/2-3;
  c.x=Math.max(-Math.max(0,extraX)/w,Math.min(Math.max(0,extraX)/w,Number(c.x)||0));
  c.y=Math.max(-Math.max(0,extraY)/h,Math.min(Math.max(0,extraY)/h,Number(c.y)||0));
  return c;
}
function tabloriaSyncZoomSlider(){
  const slider=$('zoom');if(!slider||!original)return;
  const min=Math.ceil(tabloriaWrapMinZoom()*100);
  slider.min=String(min);slider.max=String(Math.max(300,min+200));
  slider.value=String(Math.round(working.zoom*100));
}
function cropCanvas(outW=900){if(!original)return null;const {w,h}=dims();const outH=Math.round(outW*h/w);const c=document.createElement('canvas');c.width=outW;c.height=outH;const ctx=c.getContext('2d');const base=Math.max(outW/original.naturalWidth,outH/original.naturalHeight)*crop.zoom;const iw=original.naturalWidth*base,ih=original.naturalHeight*base;const ox=(outW-iw)/2+crop.x*outW,oy=(outH-ih)/2+crop.y*outH;ctx.drawImage(original,ox,oy,iw,ih);return c}

/* V15.11 — previzualizarea fotografiei încadrate, deasupra simulatorului. */
(function addFinalCropPreview(){
  const root=$('tabloria-configurator');
  const simulation=$('scene')?.closest('.panel');
  if(!root||!simulation)return;
  const block=document.createElement('section');
  block.id='tabloria-final-crop';
  block.hidden=true;
  block.setAttribute('aria-label','Previzualizarea fotografiei încadrate');
  block.innerHTML='<h3>4. Simulator 3D</h3><div class="tabloria-final-image"><img id="tabloria-final-photo" alt="Fotografia încadrată pentru tabloul Canvas"></div><p class="tabloria-final-note">Aceasta este încadrarea fotografiei care va fi imprimată pe fața tabloului.</p>';
  simulation.insertBefore(block,simulation.firstChild);
  const style=document.createElement('style');
  style.textContent=`
    #tabloria-configurator #tabloria-final-crop[hidden]{display:none!important}
    #tabloria-configurator #tabloria-final-crop{margin-bottom:18px}
    #tabloria-configurator #tabloria-final-crop h3{font-size:15px;font-weight:700;margin:0 0 12px;color:#252b30}
    #tabloria-configurator .tabloria-final-image{display:flex;justify-content:center;align-items:center;background:#f7f8fa;border:1px solid #e3e6e9;border-radius:12px;padding:12px;min-height:120px}
    #tabloria-configurator .tabloria-final-image img{display:block;width:auto;height:auto;max-width:100%;max-height:300px;object-fit:contain;border-radius:3px}
    #tabloria-configurator .tabloria-final-note{font-size:12px;line-height:1.5;color:#697078;margin:9px 0 18px}
    #tabloria-configurator #tabloria-final-crop .tabloria-simulator-heading{margin:0 0 12px}
    @media(max-width:600px){#tabloria-configurator .tabloria-final-image img{max-height:260px}}
  `;
  root.appendChild(style);
})();
function syncFinalCropPreview(){
  const block=$('tabloria-final-crop'),photo=$('tabloria-final-photo'),source=$('preview');
  if(!block||!photo||!source)return;
  if(!original||!source.src){block.hidden=true;const h=$('tabloria-step5-heading');if(h)h.hidden=false;return;}
  photo.src=source.src;
  block.hidden=false;const h=$('tabloria-step5-heading');if(h)h.hidden=false;
}

function updateCropPreview(){if(!original)return;tabloriaConstrainCrop(crop);const c=cropCanvas(1100);$('preview').src=c.toDataURL('image/jpeg',.9);$('preview').hidden=false;$('empty').hidden=true;$('handsPreview').src=$('preview').src;$('handsPreview').hidden=false;$('handsEmpty').hidden=true;syncFinalCropPreview();if(tabloria3D.ready&&tabloria3D.active)paintTabloria3D();if(tabloria3D.ready)paintTabloriaMini3D();}

/* V15.29 — două chenare în editor: fața + rezervă reală de 3 cm pe fiecare latură. */
(function setupTabloriaWrapGuides(){
  const stage=$('cropStage'),box=$('cropBox');
  if(!stage||!box)return;
  const style=document.createElement('style');
  style.id='tabloria-canvas-wrap-guides-v1528';
  style.textContent=`
    #tabloria-configurator #cropBox{position:relative!important;overflow:visible!important;isolation:isolate}
    #tabloria-configurator #cropBox #cropImage{z-index:0}
    #tabloria-configurator #cropBox::before{content:'';position:absolute;inset:0;z-index:4;pointer-events:none;border:2px solid #fff;box-shadow:inset 0 0 0 1px #252b30,0 0 0 1px #252b30}
    #tabloria-configurator #cropBox::after{content:'';position:absolute;top:calc(-1 * var(--tabloria-wrap-y, 0px));bottom:calc(-1 * var(--tabloria-wrap-y, 0px));left:calc(-1 * var(--tabloria-wrap-x, 0px));right:calc(-1 * var(--tabloria-wrap-x, 0px));z-index:5;pointer-events:none;border:3px dashed #ff641f;box-sizing:border-box;box-shadow:0 0 0 1px rgba(255,255,255,.85)}
    #tabloria-configurator #tabloria-wrap-guide-note{font-size:12px;line-height:1.5;color:#252b30;text-align:center;margin:8px 0 10px}
  `;
  document.head.appendChild(style);
  const note=document.createElement('p');note.id='tabloria-wrap-guide-note';
  note.textContent='Chenar alb: fața tabloului. Chenar portocaliu: +3 cm pe fiecare latură, pentru îmbrăcarea Canvasului. Fotografia trebuie să acopere ambele chenare.';
  stage.insertAdjacentElement('afterend',note);
})();
function sizeCrop(){
  const {w,h}=dims(),stage=$('cropStage'),box=$('cropBox');
  // Încadrăm în ecran ÎNTREAGA pânză desfășurată (w+6 × h+6), nu doar fața.
  const scale=Math.min(Math.max(1,stage.clientWidth-38)/(w+6),Math.max(1,stage.clientHeight-32)/(h+6));
  box.style.width=Math.floor(w*scale)+'px';box.style.height=Math.floor(h*scale)+'px';
  box.style.setProperty('--tabloria-wrap-x',(3*scale)+'px');
  box.style.setProperty('--tabloria-wrap-y',(3*scale)+'px');
  positionCrop();
}

function positionCrop(){if(!original)return;tabloriaConstrainCrop(working);tabloriaSyncZoomSlider();const box=$('cropBox'),bw=box.clientWidth,bh=box.clientHeight;const base=Math.max(bw/original.naturalWidth,bh/original.naturalHeight)*working.zoom,iw=original.naturalWidth*base,ih=original.naturalHeight*base;const reserveX=3/dims().w,reserveY=3/dims().h;working.x=Math.max(-Math.max(0,(iw-bw)/(2*bw)-reserveX),Math.min(Math.max(0,(iw-bw)/(2*bw)-reserveX),working.x));working.y=Math.max(-Math.max(0,(ih-bh)/(2*bh)-reserveY),Math.min(Math.max(0,(ih-bh)/(2*bh)-reserveY),working.y));const im=$('cropImage');im.style.width=iw+'px';im.style.height=ih+'px';im.style.left=((bw-iw)/2+working.x*bw)+'px';im.style.top=((bh-ih)/2+working.y*bh)+'px';$('zoomText').textContent=Math.round(working.zoom*100)+'%'}

function openCrop(){if(!original){alert('Încarcă mai întâi o fotografie.');return}working=tabloriaConstrainCrop({...crop});tabloriaSyncZoomSlider();$('zoom').value=Math.round(working.zoom*100);$('cropImage').src=originalURL;$('modal').classList.add('open');requestAnimationFrame(sizeCrop)}

function closeCrop(apply){if(apply){viewMode='auto';detail=false;tabloria3D.active=false;crop={...working};tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;updateCropPreview();render()}$('modal').classList.remove('open');if(apply)tabloriaScheduleCropUpload()}

/* V15.9 — pinch-to-zoom pe telefon, drag cu un deget și cursor păstrat.
   touch-action:none împiedică browserul să interpreteze gestul ca zoom al paginii. */
(function enableTouchCrop(){
  const box=$('cropBox');
  box.style.touchAction='none';
  $('cropImage').style.touchAction='none';
  const pointers=new Map();
  let gesture=null;
  const clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
  const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
  const midpoint=(a,b)=>({x:(a.x+b.x)/2,y:(a.y+b.y)/2});
  function beginGesture(){
    const points=[...pointers.values()];
    if(!points.length){gesture=null;return;}
    if(points.length===1){
      gesture={mode:'pan',start:points[0],x:working.x,y:working.y};
    }else{
      gesture={mode:'pinch',startDistance:Math.max(1,distance(points[0],points[1])),
        startMid:midpoint(points[0],points[1]),zoom:working.zoom,x:working.x,y:working.y};
    }
  }
  box.addEventListener('pointerdown',e=>{
    if(e.pointerType==='mouse'&&e.button!==0)return;
    e.preventDefault();
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    try{box.setPointerCapture(e.pointerId);}catch(_){}
    beginGesture();
  });
  box.addEventListener('pointermove',e=>{
    if(!pointers.has(e.pointerId))return;
    e.preventDefault();
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    const points=[...pointers.values()];
    if(!gesture)return;
    if(points.length===1&&gesture.mode==='pan'){
      working.x=gesture.x+(points[0].x-gesture.start.x)/box.clientWidth;
      working.y=gesture.y+(points[0].y-gesture.start.y)/box.clientHeight;
    }else if(points.length>=2&&gesture.mode==='pinch'){
      const mid=midpoint(points[0],points[1]);
      const nextZoom=clamp(gesture.zoom*distance(points[0],points[1])/gesture.startDistance,tabloriaWrapMinZoom(),Math.max(3,tabloriaWrapMinZoom()+2));
      const factor=nextZoom/gesture.zoom;
      const rect=box.getBoundingClientRect();
      const anchorX=(gesture.startMid.x-rect.left)/box.clientWidth-0.5;
      const anchorY=(gesture.startMid.y-rect.top)/box.clientHeight-0.5;
      // Păstrează sub degete același punct din fotografie în timpul măririi.
      working.x=gesture.x*factor+anchorX*(1-factor)+(mid.x-gesture.startMid.x)/box.clientWidth;
      working.y=gesture.y*factor+anchorY*(1-factor)+(mid.y-gesture.startMid.y)/box.clientHeight;
      working.zoom=nextZoom;
      $('zoom').value=Math.round(nextZoom*100);
    }
    positionCrop();
  });
  function endPointer(e){
    if(!pointers.has(e.pointerId))return;
    pointers.delete(e.pointerId);
    try{if(box.hasPointerCapture(e.pointerId))box.releasePointerCapture(e.pointerId);}catch(_){}
    beginGesture();
  }
  box.addEventListener('pointerup',endPointer);
  box.addEventListener('pointercancel',endPointer);
  box.addEventListener('lostpointercapture',endPointer);
  // Curăță gesturile dacă utilizatorul închide popup-ul în mijlocul unei atingeri.
  ['close','cancel','apply'].forEach(id=>$(id)?.addEventListener('click',()=>{pointers.clear();gesture=null;}));
})();

$('zoom').oninput=e=>{working.zoom=Number(e.target.value)/100;positionCrop()};$('edit').onclick=openCrop;$('close').onclick=()=>closeCrop(false);$('cancel').onclick=()=>closeCrop(false);// Canvas V15.42: confirmare la prima atingere pe mobil.
const applyCropButton=$('apply');
let applyTouchHandled=false;
applyCropButton.addEventListener('pointerup',e=>{
  if(e.pointerType!=='touch'&&e.pointerType!=='pen')return;
  if(applyTouchHandled)return;
  applyTouchHandled=true;
  e.preventDefault();
  applyCropButton.blur();
  closeCrop(true);
  setTimeout(()=>{applyTouchHandled=false;},450);
});
applyCropButton.addEventListener('click',e=>{
  if(applyTouchHandled){e.preventDefault();return;}
  closeCrop(true);
});$('modal').onclick=e=>{if(e.target===$('modal'))closeCrop(false)};document.addEventListener('keydown',e=>{if(e.key==='Escape')closeCrop(false)});

$('file').onchange=e=>{const file=e.target.files?.[0];if(!file)return;if(originalURL)URL.revokeObjectURL(originalURL);originalURL=URL.createObjectURL(file);const im=new Image();im.onload=()=>{original=im;viewMode='auto';detail=false;tabloria3D.active=false;tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;crop={zoom:1,x:0,y:0};$('quality').textContent=`${file.name} · ${im.naturalWidth} × ${im.naturalHeight} px`;updateCropPreview();render();openCrop()};im.onerror=()=>alert('Imaginea nu poate fi deschisă. Folosește JPG sau PNG.');im.src=originalURL};

$('vertical').onclick=()=>{landscape=false;tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;crop={zoom:1,x:0,y:0};updateCropPreview();render()};$('horizontal').onclick=()=>{landscape=true;tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;crop={zoom:1,x:0,y:0};updateCropPreview();render()};$('roomTab').onclick=()=>{tabloria3D.active=false;detail=false;viewMode='room';render()};$('handsTab').onclick=()=>{tabloria3D.active=false;detail=false;viewMode='hands';render()};$('detailTab').onclick=()=>{tabloria3D.active=false;detail=true;viewMode='detail';render()};window.addEventListener('resize',()=>{render();if($('modal').classList.contains('open'))sizeCrop();if(tabloria3D.active)paintTabloria3D();paintTabloriaMini3D()});

function saveBlob(blob,name){const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download=name;a.click();setTimeout(()=>URL.revokeObjectURL(url),3000)}

$('download').onclick=()=>{if(!original){alert('Încarcă întâi fotografia.');return}const {w,h}=dims(),c=cropCanvas(Math.round(w*25));c.toBlob(b=>b&&saveBlob(b,`tabloria-${w}x${h}.jpg`),'image/jpeg',.93)};


/* V15.18 — Three.js / WebGL. Exclusiv previzualizare, fără schimbări Upload-Lift. */
const tabloria3D={rx:-5,ry:26,active:false,ready:false,signature:'',renderer:null,scene:null,camera:null,mesh:null,materials:[],loading:null,zoom:1,group:null,backParts:[],miniRenderer:null,miniCamera:null,miniRx:-5,miniRy:26,miniZoom:1};
function loadTabloriaThree(){
  if(window.THREE)return Promise.resolve(window.THREE);
  if(tabloria3D.loading)return tabloria3D.loading;
  tabloria3D.loading=new Promise((resolve,reject)=>{
    const script=document.createElement('script');
    script.src='https://cdnjs.cloudflare.com/ajax/libs/three.js/0.149.0/three.min.js';
    script.async=true;
    script.onload=()=>window.THREE?resolve(window.THREE):reject(Error('Biblioteca 3D nu s-a încărcat.'));
    script.onerror=()=>reject(Error('Nu s-a putut încărca biblioteca 3D. Verifică accesul la cdnjs.cloudflare.com.'));
    document.head.appendChild(script);
  }).catch(err=>{tabloria3D.loading=null;throw err});
  return tabloria3D.loading;
}
function setupTabloria3D(){
  const root=$('tabloria-configurator'),room=$('roomTab');
  if(!root||!room||$('tabloria3DTab'))return;
  const btn=document.createElement('button');btn.type='button';btn.id='tabloria3DTab';btn.textContent='3D interactiv';room.parentElement.appendChild(btn);btn.hidden=true;
  const stage=document.createElement('div');stage.id='tabloria3DStage';stage.hidden=true;
  stage.innerHTML='<div class="tabloria3DViewport" id="tabloria3DViewport" aria-label="Simulare Canvas 3D rotativ"></div><div class="tabloria3DHelp">Glisează pentru rotire · două degete pentru zoom</div><div id="tabloria3DEdgeNotice" hidden></div><div class="tabloria3DControls"><button type="button" id="tabloria3DMinus" aria-label="Micșorează tabloul">−</button><span id="tabloria3DZoomLabel">100%</span><button type="button" id="tabloria3DPlus" aria-label="Mărește tabloul">+</button></div><button type="button" id="tabloria3DReset">Resetează poziția</button>';
  room.parentElement.insertAdjacentElement('afterend',stage);
  const style=document.createElement('style');style.textContent=`
    #tabloria-configurator #tabloria3DStage[hidden],#tabloria-configurator #tabloria3DEdgeNotice[hidden]{display:none!important}
    #tabloria-configurator #tabloria3DTab{display:none!important}
    #tabloria-configurator #tabloria3DTab.active{background:#ff641f;color:white;border-color:#ff641f}
    #tabloria-configurator #tabloria3DStage{padding:10px 0 15px;text-align:center}
    #tabloria-configurator .tabloria3DViewport{height:360px;width:100%;position:relative;background:radial-gradient(ellipse at center,#fff 10%,#edf0f2 100%);border-radius:14px;overflow:hidden;touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}
    #tabloria-configurator .tabloria3DViewport:active{cursor:grabbing}
    #tabloria-configurator .tabloria3DViewport canvas{display:block;width:100%;height:100%;touch-action:none}
    #tabloria-configurator .tabloria3DHelp{font-size:12px;color:#697078;margin:10px 0}
    #tabloria-configurator #tabloria3DEdgeNotice{font-size:12px;line-height:1.45;color:#a34b18;margin:6px 12px 12px}
    #tabloria-configurator .tabloria3DControls{display:flex;justify-content:center;align-items:center;gap:12px;margin:12px 0}
    #tabloria-configurator .tabloria3DControls button{width:44px;height:44px;border:1px solid #ff641f;border-radius:10px;background:#fff;color:#b94510;font-size:25px;font-weight:700;touch-action:manipulation}
    #tabloria-configurator #tabloria3DZoomLabel{min-width:52px;font-weight:700;color:#252b30}
    #tabloria-configurator #tabloria3DReset{padding:9px 17px;border:1px solid #ff641f;border-radius:9px;background:#fff;color:#b94510;font-weight:600;cursor:pointer}
    @media(max-width:600px){#tabloria-configurator .tabloria3DViewport{height:320px}#tabloria-configurator #tabloria3DTab{font-size:12px;padding-left:6px;padding-right:6px}}
  `;root.appendChild(style);
  const viewport=$('tabloria3DViewport');
  const pointers=new Map();let gesture=null;
  const clamp=(n,min,max)=>Math.max(min,Math.min(max,n));
  const dist=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
  function startGesture(){
    const pts=[...pointers.values()];
    if(pts.length>=2)gesture={type:'pinch',distance:Math.max(1,dist(pts[0],pts[1])),zoom:tabloria3D.zoom};
    else if(pts.length===1)gesture={type:'rotate',x:pts[0].x,y:pts[0].y,rx:tabloria3D.rx,ry:tabloria3D.ry};
    else gesture=null;
  }
  viewport.addEventListener('pointerdown',e=>{
    if(e.pointerType==='mouse'&&e.button!==0)return;
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    try{viewport.setPointerCapture(e.pointerId)}catch(_){}
    startGesture();e.preventDefault();
  });
  viewport.addEventListener('pointermove',e=>{
    if(!pointers.has(e.pointerId))return;
    pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});
    const pts=[...pointers.values()];
    if(gesture?.type==='pinch'&&pts.length>=2){
      tabloria3D.zoom=clamp(gesture.zoom*dist(pts[0],pts[1])/gesture.distance,.5,2);
    }else if(gesture?.type==='rotate'&&pts.length===1){
      tabloria3D.ry=gesture.ry+(pts[0].x-gesture.x)*.65;
      tabloria3D.rx=clamp(gesture.rx-(pts[0].y-gesture.y)*.55,-85,85);
    }
    paintTabloria3D();e.preventDefault();
  });
  function release(e){if(!pointers.has(e.pointerId))return;pointers.delete(e.pointerId);startGesture()}
  viewport.addEventListener('pointerup',release);
  viewport.addEventListener('pointercancel',release);
  viewport.addEventListener('lostpointercapture',release);
  viewport.addEventListener('wheel',e=>{e.preventDefault();tabloria3D.zoom=clamp(tabloria3D.zoom*(e.deltaY>0?.92:1.08),.5,2);paintTabloria3D()},{passive:false});
  $('tabloria3DMinus').onclick=()=>{tabloria3D.zoom=clamp(tabloria3D.zoom-.15,.5,2);paintTabloria3D()};
  $('tabloria3DPlus').onclick=()=>{tabloria3D.zoom=clamp(tabloria3D.zoom+.15,.5,2);paintTabloria3D()};
  $('tabloria3DReset').onclick=()=>{tabloria3D.rx=-5;tabloria3D.ry=26;tabloria3D.zoom=1;paintTabloria3D()};
  btn.onclick=()=>{tabloria3D.active=true;detail=false;viewMode='3d';render()};
  tabloria3D.ready=true;
}
/* V15.23 — margini Canvas acoperite automat în toate vizualizările 3D.
   Folosește fotografia originală în afara încadrării când există pixeli reali.
   În afara fotografiei, continuă pixelii de la limita reală fără oglindire
   sau repetarea unor fâșii. Fața rămâne identică cu cropCanvas().
   IMPORTANT: această textură este doar pentru simulare; nu schimbă Upload-Lift. */
/* V15.24: galerie-wrap din PIXELI REALI ai fotografiei originale.
   Imaginea se ajusteaza exclusiv in previzualizarea 3D pentru a acoperi
   suprafata desfasurata (fata + 3 cm pe fiecare latura). Nu se inventeaza pixeli. */
/* V15.25 — Fața rămâne EXACT cropCanvas; marginile preiau exclusiv
   conținut real adiacent din original când există. Dacă imaginea se termină,
   extindem ultimul pixel numai pentru previzualizare, fără inventarea detaliilor. */
/* V15.32 — vedere spre marginea dreaptă (+X), aceeași geometrie UV în toate randările. */
/* V15.30 — atlas de pânză: imaginea originală acoperă întreaga desfășurată.
   Cele patru laturi sunt orientate după UV-urile reale ale BoxGeometry.
   Fața și marginile provin din exact aceeași operație de decupare. */
function makeTabloriaTextures(){
  // Un singur atlas pentru toate fețele: fără inversări sau UV-uri independente.
  if(original)tabloriaConstrainCrop(crop);
  const {w,h}=dims(),faceW=1200,faceH=Math.round(1200*h/w);
  const edgeX=Math.round(faceW*3/w),edgeY=Math.round(faceH*3/h);
  const canvas=document.createElement('canvas');
  canvas.width=faceW+edgeX*2;canvas.height=faceH+edgeY*2;
  const ctx=canvas.getContext('2d');
  if(original){
    const scale=Math.max(faceW/original.naturalWidth,faceH/original.naturalHeight)*crop.zoom;
    const iw=original.naturalWidth*scale,ih=original.naturalHeight*scale;
    const ox=edgeX+(faceW-iw)/2+crop.x*faceW;
    const oy=edgeY+(faceH-ih)/2+crop.y*faceH;
    ctx.drawImage(original,ox,oy,iw,ih);
    // Extindere doar de siguranță pentru rotunjiri subpixel.
    const l=Math.max(0,Math.ceil(ox)),r=Math.min(canvas.width,Math.floor(ox+iw));
    const t=Math.max(0,Math.ceil(oy)),b=Math.min(canvas.height,Math.floor(oy+ih));
    if(r>l&&b>t){
      if(l>0)ctx.drawImage(canvas,l,t,1,b-t,0,t,l,b-t);
      if(r<canvas.width)ctx.drawImage(canvas,r-1,t,1,b-t,r,t,canvas.width-r,b-t);
      if(t>0)ctx.drawImage(canvas,0,t,canvas.width,1,0,0,canvas.width,t);
      if(b<canvas.height)ctx.drawImage(canvas,0,b-1,canvas.width,1,0,b,canvas.width,canvas.height-b);
    }
  }else{ctx.fillStyle='#e4ddd0';ctx.fillRect(0,0,canvas.width,canvas.height);}
  return {canvas,faceW,faceH,edgeX,edgeY};
}
function makeTabloriaWrappedGeometry(THREE,w,h,atlas){
  const geometry=new THREE.BoxGeometry(w,h,3);
  const positions=geometry.attributes.position,uv=geometry.attributes.uv;
  const aw=atlas.canvas.width,ah=atlas.canvas.height;
  for(let i=0;i<positions.count;i++){
    const x=positions.getX(i),y=positions.getY(i),z=positions.getZ(i);
    const face=Math.floor(i/4); // BoxGeometry: +X,-X,+Y,-Y,+Z,-Z
    let px,py;
    if(face===0){ // dreapta: +Z lângă față, -Z spre spate
      px=atlas.edgeX+atlas.faceW+(1.5-z)/3*atlas.edgeX;
      py=atlas.edgeY+(h/2-y)/h*atlas.faceH;
    }else if(face===1){
      px=atlas.edgeX-(1.5-z)/3*atlas.edgeX;
      py=atlas.edgeY+(h/2-y)/h*atlas.faceH;
    }else if(face===2){
      px=atlas.edgeX+(x+w/2)/w*atlas.faceW;
      py=atlas.edgeY-(1.5-z)/3*atlas.edgeY;
    }else if(face===3){
      px=atlas.edgeX+(x+w/2)/w*atlas.faceW;
      py=atlas.edgeY+atlas.faceH+(1.5-z)/3*atlas.edgeY;
    }else{
      px=atlas.edgeX+(x+w/2)/w*atlas.faceW;
      py=atlas.edgeY+(h/2-y)/h*atlas.faceH;
    }
    uv.setXY(i,px/aw,1-py/ah);
  }
  uv.needsUpdate=true;
  return geometry;
}

function disposeTabloria3D(){
  if(tabloria3D.group){tabloria3D.scene.remove(tabloria3D.group);tabloria3D.group=null;tabloria3D.mesh=null;}
  tabloria3D.backParts.forEach(part=>{part.geometry.dispose();part.material.dispose()});tabloria3D.backParts=[];
  if(tabloria3D.boxGeometry){tabloria3D.boxGeometry.dispose();tabloria3D.boxGeometry=null;}
  new Set(tabloria3D.materials).forEach(m=>{m.map?.dispose();m.dispose()});tabloria3D.materials=[];
}
function makeTabloriaCanvasBack(THREE,group,w,h){
  // Spate real: șasiul se află ÎN SPATELE pânzei, nu ascuns în blocul 3D.
  // +Z = fața imprimată, -Z = spatele Canvasului.
  const add=(geometry,material,x,y,z)=>{
    const part=new THREE.Mesh(geometry,material);
    part.position.set(x,y,z);group.add(part);tabloria3D.backParts.push(part);return part;
  };
  const wood=new THREE.MeshStandardMaterial({color:0xcba16a,roughness:.91});
  const linen=new THREE.MeshStandardMaterial({color:0xe4ddd0,roughness:1,side:THREE.DoubleSide});
  const staple=new THREE.MeshBasicMaterial({color:0x77746e});
  const rail=Math.min(3.7,Math.max(1.9,Math.min(w,h)*.09));
  const depth=1.05;
  // Pânza închisă la culoarea naturală, în spatele fotografiei și sub cadrul de lemn.
  // Suprafața este la z=-1.505; cadrul iese spre exterior până la z=-2.57.
  add(new THREE.PlaneGeometry(w-.16,h-.16),linen,0,0,-1.515);
  const railZ=-1.515-depth/2-.025;
  add(new THREE.BoxGeometry(rail,h-.12,depth),wood,-w/2+rail/2,0,railZ);
  add(new THREE.BoxGeometry(rail,h-.12,depth),wood,w/2-rail/2,0,railZ);
  add(new THREE.BoxGeometry(w-2*rail,rail,depth),wood,0,h/2-rail/2,railZ);
  add(new THREE.BoxGeometry(w-2*rail,rail,depth),wood,0,-h/2+rail/2,railZ);
  // Traversele sunt adăugate doar la tablouri mari.
  if(w>=60)add(new THREE.BoxGeometry(rail*.72,h-2*rail,depth*.78),wood,0,0,railZ-.08);
  if(h>=85)add(new THREE.BoxGeometry(w-2*rail,rail*.72,depth*.78),wood,0,0,railZ-.08);
  // Capse discrete pe laturile șasiului, ca la un Canvas montat.
  const step=Math.max(5,Math.min(w,h)/5);
  for(let y=-h/2+rail;y<=h/2-rail;y+=step){
    for(const x of [-w/2+rail*.48,w/2-rail*.48])
      add(new THREE.BoxGeometry(.32,.07,.025),staple,x,y,railZ-depth/2-.018);
  }
  for(let x=-w/2+rail;x<=w/2-rail;x+=step){
    for(const y of [-h/2+rail*.48,h/2-rail*.48])
      add(new THREE.BoxGeometry(.32,.07,.025),staple,x,y,railZ-depth/2-.018);
  }
}
function initTabloria3D(){
  if(tabloria3D.renderer)return Promise.resolve();
  return loadTabloriaThree().then(THREE=>{
    if(tabloria3D.renderer)return;
    const viewport=$('tabloria3DViewport');
    const renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,powerPreference:'low-power'});
    renderer.setPixelRatio(Math.min(window.devicePixelRatio||1,2));
    renderer.setSize(Math.max(1,viewport.clientWidth),Math.max(1,viewport.clientHeight));
    renderer.outputEncoding=THREE.sRGBEncoding;
    viewport.appendChild(renderer.domElement);
    const scene=new THREE.Scene(),camera=new THREE.PerspectiveCamera(38,1,.1,2000);
    scene.add(new THREE.AmbientLight(0xffffff,1.25));
    const light=new THREE.DirectionalLight(0xffffff,1.15);light.position.set(-70,90,130);scene.add(light);
    tabloria3D.renderer=renderer;tabloria3D.scene=scene;tabloria3D.camera=camera;
    renderer.domElement.addEventListener('webglcontextlost',e=>{e.preventDefault();$('tabloria3DHelp').textContent='Randarea 3D a fost întreruptă. Reîncarcă pagina.'});
  });
}
function paintTabloria3D(){
  if(!tabloria3D.ready||!tabloria3D.active)return;
  if(!tabloria3D.renderer){
    if(!tabloria3D.loadingPaint){
      tabloria3D.loadingPaint=true;
      initTabloria3D().then(()=>{tabloria3D.loadingPaint=false;paintTabloria3D()}).catch(err=>{tabloria3D.loadingPaint=false;$('tabloria3DHelp').textContent=err.message});
    }
    return;
  }
  const THREE=window.THREE,{w,h}=dims(),state=tabloria3D,viewport=$('tabloria3DViewport');
  const width=Math.max(1,viewport.clientWidth),height=Math.max(1,viewport.clientHeight);
  state.renderer.setSize(width,height,false);state.camera.aspect=width/height;state.camera.updateProjectionMatrix();
  const signature=JSON.stringify([w,h,crop.zoom,crop.x,crop.y,originalURL]);
  if(signature!==state.signature){
    disposeTabloria3D();
    const data=makeTabloriaTextures();
    const notice=$('tabloria3DEdgeNotice');if(notice)notice.hidden=true;
    const atlasTexture=new THREE.CanvasTexture(data.canvas);
    atlasTexture.encoding=THREE.sRGBEncoding;
    atlasTexture.minFilter=THREE.LinearFilter;
    atlasTexture.magFilter=THREE.LinearFilter;
    atlasTexture.generateMipmaps=false;
    atlasTexture.wrapS=THREE.ClampToEdgeWrapping;
    atlasTexture.wrapT=THREE.ClampToEdgeWrapping;
    // Aceeași textură pentru față și toate cele patru laterale.
    const frontMaterial=new THREE.MeshBasicMaterial({map:atlasTexture});
    const mats=[frontMaterial,frontMaterial,frontMaterial,frontMaterial,frontMaterial,
      new THREE.MeshBasicMaterial({transparent:true,opacity:0,depthWrite:false,side:THREE.DoubleSide})];
    state.materials=mats;
    state.group=new THREE.Group();
    state.boxGeometry=makeTabloriaWrappedGeometry(THREE,w,h,data);
    state.mesh=new THREE.Mesh(state.boxGeometry,mats);
    state.group.add(state.mesh);
    makeTabloriaCanvasBack(THREE,state.group,w,h);
    state.scene.add(state.group);state.signature=signature;
  }
  const vFov=state.camera.fov*Math.PI/180;
  const dist=(Math.hypot(w,h,5.5)/2)/(Math.tan(vFov/2))*1.23;
  state.camera.position.set(0,0,dist/state.zoom);state.camera.lookAt(0,0,0);
  state.group.rotation.order='YXZ';state.group.rotation.y=state.ry*Math.PI/180;state.group.rotation.x=state.rx*Math.PI/180;
  $('tabloria3DZoomLabel').textContent=Math.round(state.zoom*100)+'%';
  state.renderer.render(state.scene,state.camera);
  paintTabloriaMini3D();
}
function syncTabloria3D(){
  if(!tabloria3D.ready)return;
  const active=tabloria3D.active;
  $('tabloria3DStage').hidden=!active;
  $('tabloria3DTab').classList.toggle('active',active);
  if(active)for(const id of ['roomTab','handsTab','detailTab'])$(id)?.classList.remove('active');
  if(active){$('scene').hidden=true;$('handsScene').hidden=true;paintTabloria3D()}
}

/* V15.19 — a doua vedere WebGL, în locul fotografiei plane de la pasul 4.
   Refolosește geometria și texturile 3D, fără modificări la fotografiile pentru comandă. */
let tabloriaMiniLoading=false,tabloriaMiniPainting=false;
function setupTabloriaMini3D(){
  const container=document.querySelector('#tabloria-configurator .tabloria-final-image');
  if(!container||document.getElementById('tabloriaMiniViewport'))return;
  const photo=$('tabloria-final-photo');if(photo)photo.style.display='none';
  const viewport=document.createElement('div');viewport.id='tabloriaMiniViewport';
  viewport.setAttribute('aria-label','Previzualizare 3D interactivă a tabloului');
  container.appendChild(viewport);
  const resetMini=document.createElement('button');resetMini.type='button';resetMini.id='tabloriaMiniReset';resetMini.textContent='Resetează vederea 3D';container.insertAdjacentElement('afterend',resetMini);resetMini.onclick=()=>{tabloria3D.miniRx=-5;tabloria3D.miniRy=26;tabloria3D.miniZoom=1;paintTabloriaMini3D()};
  const note=document.querySelector('#tabloria-final-crop .tabloria-final-note');
  if(note)note.textContent='Rotește tabloul cu degetul sau mouse-ul. Folosește două degete pentru zoom. Simularea este orientativă.';
  const style=document.createElement('style');style.textContent=`
    #tabloria-configurator .tabloria-final-image{padding:0;overflow:hidden}
    #tabloria-configurator #tabloriaMiniViewport{height:300px;width:100%;min-width:0;position:relative;background:radial-gradient(ellipse at center,#fff 10%,#edf0f2 100%);touch-action:none;cursor:grab;user-select:none;-webkit-user-select:none}
    #tabloria-configurator #tabloriaMiniViewport:active{cursor:grabbing}
    #tabloria-configurator #tabloriaMiniReset{display:block;margin:10px auto 4px;padding:9px 15px;border:1px solid #ff641f;background:#fff;color:#b94510;border-radius:9px;font-weight:600;cursor:pointer}
    #tabloria-configurator #tabloriaMiniViewport canvas{display:block;width:100%;height:100%;touch-action:none}
    @media(max-width:600px){#tabloria-configurator #tabloriaMiniViewport{height:260px}}
  `;document.getElementById('tabloria-configurator').appendChild(style);
  const pointers=new Map();let gesture=null;
  const clamp=(v,min,max)=>Math.max(min,Math.min(max,v));
  const distance=(a,b)=>Math.hypot(a.x-b.x,a.y-b.y);
  const begin=()=>{const pts=[...pointers.values()];gesture=pts.length>=2?{type:'pinch',distance:Math.max(1,distance(pts[0],pts[1])),zoom:tabloria3D.miniZoom}:pts.length===1?{type:'rotate',x:pts[0].x,y:pts[0].y,rx:tabloria3D.miniRx,ry:tabloria3D.miniRy}:null};
  viewport.addEventListener('pointerdown',e=>{if(e.pointerType==='mouse'&&e.button!==0)return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});try{viewport.setPointerCapture(e.pointerId)}catch(_){}begin();e.preventDefault()});
  viewport.addEventListener('pointermove',e=>{if(!pointers.has(e.pointerId))return;pointers.set(e.pointerId,{x:e.clientX,y:e.clientY});const pts=[...pointers.values()];if(gesture?.type==='pinch'&&pts.length>=2)tabloria3D.miniZoom=clamp(gesture.zoom*distance(pts[0],pts[1])/gesture.distance,.5,2);else if(gesture?.type==='rotate'&&pts.length===1){tabloria3D.miniRy=gesture.ry+(pts[0].x-gesture.x)*.65;tabloria3D.miniRx=clamp(gesture.rx-(pts[0].y-gesture.y)*.55,-85,85)}paintTabloriaMini3D();e.preventDefault()});
  const release=e=>{if(!pointers.has(e.pointerId))return;pointers.delete(e.pointerId);begin()};
  ['pointerup','pointercancel','lostpointercapture'].forEach(name=>viewport.addEventListener(name,release));
  viewport.addEventListener('wheel',e=>{e.preventDefault();tabloria3D.miniZoom=clamp(tabloria3D.miniZoom*(e.deltaY>0?.92:1.08),.5,2);paintTabloriaMini3D()},{passive:false});
}
function paintTabloriaMini3D(){
  const viewport=$('tabloriaMiniViewport');
  if(!viewport||!original||!tabloria3D.ready||tabloriaMiniPainting)return;
  if(tabloria3D.scene&&tabloria3D.group){const {w,h}=dims();const signature=JSON.stringify([w,h,crop.zoom,crop.x,crop.y,originalURL]);if(signature!==tabloria3D.signature){const prev=tabloria3D.active;tabloria3D.active=true;paintTabloria3D();tabloria3D.active=prev;}}
  if(!tabloria3D.scene||!tabloria3D.group){
    if(tabloriaMiniLoading)return;
    tabloriaMiniLoading=true;
    // Construim modelul folosind rutina existentă, chiar dacă tabul 3D principal nu e selectat.
    const stage=$('tabloria3DStage'),wasHidden=stage.hidden,wasActive=tabloria3D.active;
    stage.hidden=false;stage.style.position='absolute';stage.style.visibility='hidden';stage.style.pointerEvents='none';
    tabloria3D.active=true;
    Promise.resolve().then(()=>initTabloria3D()).then(()=>{
      paintTabloria3D();
    }).catch(err=>console.warn('Tabloria mini 3D:',err)).finally(()=>{
      tabloria3D.active=wasActive;stage.hidden=wasHidden;stage.style.position='';stage.style.visibility='';stage.style.pointerEvents='';tabloriaMiniLoading=false;paintTabloriaMini3D();
    });
    return;
  }
  tabloriaMiniPainting=true;
  try{
    const THREE=window.THREE,state=tabloria3D;
    if(!state.miniRenderer){
      state.miniRenderer=new THREE.WebGLRenderer({alpha:true,antialias:true,powerPreference:'low-power'});
      state.miniRenderer.setPixelRatio(Math.min(window.devicePixelRatio||1,1.5));
      state.miniRenderer.outputEncoding=THREE.sRGBEncoding;
      viewport.appendChild(state.miniRenderer.domElement);
      state.miniCamera=new THREE.PerspectiveCamera(38,1,.1,2000);
    }
    const width=Math.max(1,viewport.clientWidth),height=Math.max(1,viewport.clientHeight);
    state.miniRenderer.setSize(width,height,false);
    state.miniCamera.aspect=width/height;state.miniCamera.updateProjectionMatrix();
    const {w,h}=dims();const vFov=state.miniCamera.fov*Math.PI/180;
    const dist=(Math.hypot(w,h,5.5)/2)/Math.tan(vFov/2)*1.23;
    state.miniCamera.position.set(0,0,dist/state.miniZoom);state.miniCamera.lookAt(0,0,0);
    const previous={x:state.group.rotation.x,y:state.group.rotation.y,z:state.group.rotation.z,order:state.group.rotation.order};
    state.group.rotation.order='YXZ';state.group.rotation.y=state.miniRy*Math.PI/180;state.group.rotation.x=state.miniRx*Math.PI/180;state.group.rotation.z=0;
    state.miniRenderer.render(state.scene,state.miniCamera);
    state.group.rotation.order=previous.order;state.group.rotation.set(previous.x,previous.y,previous.z,previous.order);
    scheduleTabloriaPhoto3D();
  }catch(err){console.warn('Tabloria mini 3D:',err)}finally{tabloriaMiniPainting=false}
}

/* V15.22 — incadrare marita pentru fotografia 3D. */
/* V15.21 — fotografie 3D automata din unghi fix, doar pentru prezentare.
   Fara modificari la imaginea trimisa la productie sau la Upload-Lift. */
let tabloriaPhoto3DTimer=null,tabloriaPhoto3DBusy=false,tabloriaPhoto3DLast='',tabloriaPhoto3DURL=null;
function setupTabloriaPhoto3D(){
  const block=$('tabloria-final-crop');if(!block||$('tabloria-photo3d-card'))return;
  const card=document.createElement('div');card.id='tabloria-photo3d-card';card.hidden=true;
  card.innerHTML=`<div class="tabloria-photo3d-pair">
      <div class="tabloria-photo3d-item"><div class="tabloria-photo3d-frame"><img id="tabloria-photo3d-image" alt="Tablou Canvas 3D pe fundal alb"><span id="tabloria-photo3d-status">Se generează fotografia 3D…</span></div><button type="button" id="tabloria-photo3d-download" disabled>Descarcă imaginea 3D (PNG)</button></div>
    </div>`;
  // V15.37: fotografia 3D este un tab între „În mâini” și „Detaliu tablou”.
  const simulation=block.parentElement;
  const detailButton=$('detailTab');
  const tabs=detailButton?.parentElement;
  if(!tabs)return;
  const photoButton=document.createElement('button');
  photoButton.type='button';photoButton.id='tabloriaPhoto3DTab';
  photoButton.textContent='Fotografie 3D';
  tabs.insertBefore(photoButton,detailButton);
  photoButton.onclick=()=>{tabloria3D.active=false;detail=false;viewMode='photo3d';render();scheduleTabloriaPhoto3D();};
  const heading=document.createElement('h3');
  heading.className='tabloria-simulator-heading';
  heading.id='tabloria-step5-heading';
  heading.textContent='5. Vezi cum arată tabloul tău';
  simulation.insertBefore(heading,tabs);
  tabs.insertAdjacentElement('afterend',card);
  const style=document.createElement('style');style.textContent=`
    #tabloria-configurator #tabloria-step5-heading[hidden]{display:none!important}
    #tabloria-configurator #tabloria-step5-heading{font-size:16px;font-weight:700;margin:22px 0 12px;color:#252b30}
    #tabloria-configurator #tabloria-photo3d-card[hidden]{display:none!important}
    #tabloria-configurator #tabloriaPhoto3DTab.active{background:#ff641f;color:#fff;border-color:#ff641f}
    #tabloria-configurator #tabloria-photo3d-card{margin:18px 0 22px}
    #tabloria-configurator #tabloria-photo3d-card h3{font-size:16px;font-weight:700;margin:0 0 14px;color:#252b30}
    #tabloria-configurator .tabloria-photo3d-pair{display:grid;grid-template-columns:minmax(0,1fr);gap:14px;max-width:520px;margin:0 auto}
    #tabloria-configurator .tabloria-photo3d-item{min-width:0}
    #tabloria-configurator .tabloria-photo3d-item strong{display:block;margin:0 0 8px;font-size:13px;color:#252b30}
    #tabloria-configurator .tabloria-photo3d-frame{position:relative;display:flex;align-items:center;justify-content:center;background:#fff;border:1px solid #e3e6e9;border-radius:12px;overflow:hidden;aspect-ratio:1}
    #tabloria-configurator .tabloria-photo3d-frame img{display:none;width:100%;height:100%;object-fit:contain}
    #tabloria-configurator #tabloria-photo3d-status{font-size:12px;color:#697078;padding:12px;text-align:center}
    #tabloria-configurator .tabloria-photo3d-item button{margin-top:10px;padding:11px 10px;background:#ff641f;color:#fff;border:0;border-radius:10px;font-weight:700;cursor:pointer;width:100%;font-size:12px}
    #tabloria-configurator .tabloria-photo3d-item button:disabled{opacity:.55;cursor:wait}
    #tabloria-configurator .tabloria-photo3d-note{font-size:12px;color:#697078;line-height:1.5;margin:12px 0 0}
    @media(max-width:600px){#tabloria-configurator .tabloria-photo3d-pair{grid-template-columns:1fr}}
  `;$('tabloria-configurator').appendChild(style);
  $('tabloria-photo3d-download').onclick=()=>{if(!tabloriaPhoto3DURL)return;const {w,h}=dims();const a=document.createElement('a');a.href=tabloriaPhoto3DURL;a.download=`tabloria-canvas-3D-${w}x${h}.png`;document.body.appendChild(a);a.click();a.remove();};
}

function scheduleTabloriaPhoto3D(){
  if(!$('tabloria-photo3d-card')||!original)return;
  $('tabloria-photo3d-card').hidden=!(viewMode==='photo3d'&&original);
  const signature=JSON.stringify([originalURL,...Object.values(dims()).slice(0,2),crop.zoom,crop.x,crop.y]);
  if(signature===tabloriaPhoto3DLast)return;
  clearTimeout(tabloriaPhoto3DTimer);
  tabloriaPhoto3DTimer=setTimeout(()=>generateTabloriaPhoto3D(signature),500);
}
/* Export static: același grup Three.js și aceleași texturi ca în pasul 5. */
function tabloriaCompose3D(source,S){
  const c=document.createElement('canvas');c.width=S;c.height=S;
  const ctx=c.getContext('2d');ctx.fillStyle='#fff';ctx.fillRect(0,0,S,S);
  ctx.save();ctx.filter='blur(38px)';ctx.fillStyle='rgba(0,0,0,.15)';
  ctx.beginPath();ctx.ellipse(S*.51,S*.86,S*.30,S*.033,-.07,0,Math.PI*2);ctx.fill();ctx.restore();
  ctx.drawImage(source,0,0,S,S);return c;
}
async function generateTabloriaPhoto3D(signature){
  if(tabloriaPhoto3DBusy){tabloriaPhoto3DTimer=setTimeout(()=>generateTabloriaPhoto3D(signature),800);return;}
  if(!original||!$('tabloria-photo3d-card'))return;
  tabloriaPhoto3DBusy=true;
  const status=$('tabloria-photo3d-status'),img=$('tabloria-photo3d-image');
  const button=$('tabloria-photo3d-download');
  status.style.display='block';status.textContent='Se generează fotografia 3D…';button.disabled=true;
  let renderer=null;
  try{
    await initTabloria3D();
    const state=tabloria3D,{w,h}=dims(),current=JSON.stringify([w,h,crop.zoom,crop.x,crop.y,originalURL]);
    if(!state.group||state.signature!==current){
      const stage=$('tabloria3DStage'),wasHidden=stage.hidden,wasActive=state.active;
      stage.hidden=false;stage.style.position='absolute';stage.style.visibility='hidden';stage.style.pointerEvents='none';state.active=true;
      try{paintTabloria3D()}finally{state.active=wasActive;stage.hidden=wasHidden;stage.style.position='';stage.style.visibility='';stage.style.pointerEvents='';}
    }
    if(!state.group)throw Error('Modelul 3D nu este disponibil.');
    const THREE=window.THREE,S=1600;
    renderer=new THREE.WebGLRenderer({alpha:true,antialias:true,preserveDrawingBuffer:true,powerPreference:'low-power'});
    renderer.setPixelRatio(1);renderer.setSize(S,S,false);renderer.outputEncoding=THREE.sRGBEncoding;
    renderer.setClearColor(0xffffff,0);
    const camera=new THREE.PerspectiveCamera(38,1,.1,2000);
    // Fotografia 3D este mare, dar ramane integral in cadru.
    const distance=(Math.hypot(w,h,5.5)/2)/Math.tan(camera.fov*Math.PI/360)*1.06;
    camera.position.set(0,0,distance);camera.lookAt(0,0,0);
    const oldRotation=state.group.rotation.clone(),oldOrder=state.group.rotation.order;
    let studioBlob;
    try{
      state.group.rotation.order='YXZ';state.group.rotation.y=26*Math.PI/180;state.group.rotation.x=-5*Math.PI/180;
      renderer.render(state.scene,camera);
      const studio=tabloriaCompose3D(renderer.domElement,S);
      const toBlob=c=>new Promise((resolve,reject)=>c.toBlob(b=>b?resolve(b):reject(Error('Exportul PNG a eșuat.')),'image/png'));
      studioBlob=await toBlob(studio);
    }finally{state.group.rotation.order=oldOrder;state.group.rotation.copy(oldRotation);}
    const latest=JSON.stringify([originalURL,...Object.values(dims()).slice(0,2),crop.zoom,crop.x,crop.y]);
    if(signature!==latest)return;
    if(tabloriaPhoto3DURL)URL.revokeObjectURL(tabloriaPhoto3DURL);
    tabloriaPhoto3DURL=URL.createObjectURL(studioBlob);
    img.src=tabloriaPhoto3DURL;
    img.style.display='block';status.style.display='none';
    button.disabled=false;tabloriaPhoto3DLast=signature;
  }catch(err){status.style.display='block';status.textContent='Nu am putut genera fotografiile 3D: '+err.message;}
  finally{renderer?.dispose();renderer?.forceContextLoss();tabloriaPhoto3DBusy=false;}
}

setupTabloria3D();
setupTabloriaMini3D();
setupTabloriaPhoto3D();
tabloria3D.miniRx=-5;
tabloria3D.miniRy=26;
tabloria3D.miniZoom=1;

render();

const SHOP_HANDLE='tablou-canvas-personalizat-cu-poza-ta';

const SHOP_ORIGIN='https\://tabloria.myshopify.com';

const statusEl=$('shopifyStatus'),addBtn=$('addShopify');

const onStore=Boolean(window.Shopify&&location.protocol==='https:');

async function loadShopify(){

 if(!onStore){statusEl.textContent='Mod local: previzualizarea funcționează, dar adăugarea în coș este dezactivată. Instalează configuratorul în tema Shopify pentru testarea coșului.';addBtn.textContent='Coș Shopify disponibil după instalare';return;}

 try{

 const root=window.Shopify?.routes?.root||'/';const res=await fetch(root+'products/'+SHOP_HANDLE+'.js',{credentials:'same-origin'});

 if(!res.ok)throw Error('Produsul nu poate fi citit ('+res.status+').');const product=await res.json();

 for(const v of product.variants||[]){const label=String(v.option1||v.title||'').toLowerCase().replace(/\s/g,'').replace(/cm/g,'');shopifyVariants.set(label,v)}

 // Keep the landing-page price aligned with the requested Shopify variant.
 const landingParams=new URLSearchParams(location.search);
 if(!landingParams.has('tabloria_transfer')&&landingParams.has('variant')){
   const landingVariant=(product.variants||[]).find(item=>String(item.id)===landingParams.get('variant'));
   if(landingVariant){
     const landingKey=String(landingVariant.option1||landingVariant.title||'').toLowerCase().replace(/\s/g,'').replace(/cm/g,'');
     const landingIndex=sizes.findIndex(([width,height])=>width+'x'+height===landingKey);
     if(landingIndex!==-1)selected=landingIndex;
   }
 }
 shopifyReady=shopifyVariants.size>0;addBtn.disabled=!shopifyReady;addBtn.textContent='Adaugă în coș';

 statusEl.textContent='Fotografia originală și cea încadrată vor fi atașate comenzii.';render();

 }catch(e){statusEl.textContent='Nu s-a putut conecta produsul: '+e.message;addBtn.textContent='Conexiune indisponibilă';}

}

/* V15.5: citește linkul real pe care Upload-Lift l-a pus în formular.

   Nu ghicește URL-uri și nu permite adăugarea dacă linkul lipsește. */

function tabloriaUploadLink(){

  const fields=Array.from(document.querySelectorAll('input[name],textarea[name],a[href]'))

    .filter(el=>!$('tabloria-configurator').contains(el));

  const validUrl=value=>{

    if(!value)return null;

    try {const u=new URL(value,location.href);

      return u.protocol==='https:' && /(?:^|\.)storage\.googleapis\.com$|(?:^|\.)cloudlift\.app$|(?:^|\.)cloudlift\.io$/i.test(u.hostname)?u.href:null;

    }catch{return null;}

  };

  for(const el of fields){

    const name=(el.getAttribute('name')||'').toLowerCase();

    if(!/upload|properties\[/.test(name))continue;

    const url=validUrl(el.value||el.getAttribute('href'));

    if(url)return url;

  }

  // Dacă aplicația afișează linkul numai în widget, îl folosim doar dacă

  // este unicul link de fișier din zona standard a produsului.

  const links=fields.filter(el=>el.tagName==='A').map(el=>validUrl(el.href)).filter(Boolean);

  return [...new Set(links)].length===1?links[0]:null;

}

// V15.8.2 — upload dual: original + imagine decupată.
// Nu se adaugă în coș dacă Upload-Lift nu confirmă ambele linkuri.
const tabloriaUploadState={croppedSignature:'',croppedLink:null};
const wait=ms=>new Promise(resolve=>setTimeout(resolve,ms));
function cloudUrl(raw){
  if(!raw)return null;
  try{const u=new URL(String(raw),location.href);
    return u.protocol==='https:' && /(?:^|\.)(?:storage\.googleapis\.com|cloudlift\.app|cloudlift\.io)$/.test(u.hostname)?u.href:null;
  }catch{return null;}
}
function externalFileInputs(){
  return [...document.querySelectorAll('input[type="file"]')].filter(el=>!$('tabloria-configurator').contains(el));
}
function widgetArea(input){
  let node=input;
  for(let i=0;i<7&&node;i++,node=node.parentElement){
    const t=(node.innerText||'').toLowerCase();
    if(t.includes('fotografia încadrată')||t.includes('fotografia pentru tabloul tău'))return node;
  }
  return input.parentElement;
}
function widgetLabel(input){
  let node=input;
  for(let i=0;i<7&&node;i++,node=node.parentElement){
    const t=(node.innerText||'').toLowerCase();
    if(t.includes('fotografia încadrată'))return 'cropped';
    if(t.includes('fotografia pentru tabloul tău'))return 'original';
  }
  return null;
}
function getWidgetInputs(){
  const candidates=externalFileInputs();
  const cropped=candidates.filter(el=>widgetLabel(el)==='cropped');
  const originals=candidates.filter(el=>widgetLabel(el)==='original');
  if(cropped.length===1&&originals.length===1&&cropped[0]!==originals[0])return {cropped:cropped[0],original:originals[0]};
  return null;
}
function urlsInArea(area){
  if(!area)return [];
  const nodes=[area,...area.querySelectorAll('input,textarea,a[href]')];
  const values=nodes.flatMap(el=>[el.value,el.getAttribute?.('href')]);
  return [...new Set(values.map(cloudUrl).filter(Boolean))];
}
function uploadLinks(){
  const inputs=getWidgetInputs();
  if(!inputs)return null;
  const originalUrls=urlsInArea(widgetArea(inputs.original));
  const croppedUrls=urlsInArea(widgetArea(inputs.cropped));
  // Some Upload-Lift themes store links in product form hidden properties instead.
  const props=[...document.querySelectorAll('input[name],textarea[name]')]
    .filter(el=>!$('tabloria-configurator').contains(el));
  for(const el of props){
    const n=(el.name||'').toLowerCase(),url=cloudUrl(el.value);
    if(!url)continue;
    if(n.includes('incadrat')||n.includes('încadrat')||n.includes('crop'))croppedUrls.push(url);
    else if(n.includes('upload')||n.includes('original'))originalUrls.push(url);
  }
  const original=[...new Set(originalUrls)],cropped=[...new Set(croppedUrls)];
  if(original.length!==1||cropped.length!==1||original[0]===cropped[0])return null;
  return {original:original[0],cropped:cropped[0]};
}
function cropSignature(){const {w,h}=dims();return JSON.stringify([w,h,crop.zoom,crop.x,crop.y,$('file').files?.[0]?.name]);}
// V15.45: evităm săriturile de pagină induse de evenimentele Upload-Lift.
// Păstrăm poziția după confirmarea crop-ului numai cât se pregătește uploadul.
// Un scroll intenționat (mouse, touch, tastatură) dezactivează protecția.
let tabloriaScrollGuard=null;
function tabloriaProtectViewDuringUpload(){
  if(tabloriaScrollGuard)tabloriaScrollGuard.stop();
  const intendedY=window.scrollY;
  let active=true,internal=false;
  const stop=()=>{
    if(!active)return;
    active=false;
    window.removeEventListener('scroll',onScroll);
    window.removeEventListener('wheel',stop);
    window.removeEventListener('touchstart',stop);
    window.removeEventListener('pointerdown',stop);
    window.removeEventListener('keydown',onKey);
    clearTimeout(expiry);
    if(tabloriaScrollGuard?.stop===stop)tabloriaScrollGuard=null;
  };
  const onKey=e=>{if(['ArrowDown','ArrowUp','PageDown','PageUp','Home','End',' '].includes(e.key))stop();};
  const onScroll=()=>{
    if(!active||internal||Math.abs(window.scrollY-intendedY)<12)return;
    internal=true;
    window.scrollTo({top:intendedY,left:window.scrollX,behavior:'instant'});
    requestAnimationFrame(()=>{internal=false;});
  };
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('wheel',stop,{passive:true});
  window.addEventListener('touchstart',stop,{passive:true});
  window.addEventListener('pointerdown',stop,{passive:true});
  window.addEventListener('keydown',onKey);
  const expiry=setTimeout(stop,20000);
  tabloriaScrollGuard={stop};
  return stop;
}
// V15.44: pregătim fotografia în avans, după confirmarea încadrării.
// O singură încărcare pentru aceeași încadrare; la apăsarea butonului așteptăm
// încărcarea deja pornită, fără să trimitem două fișiere identice.
let tabloriaPreuploadTimer=null;
let tabloriaPreuploadPromise=null;
let tabloriaPreuploadSignature='';
function tabloriaPrepareCropUpload(){
  if(!original||!shopifyReady)return null;
  const signature=cropSignature();
  if(tabloriaPreuploadPromise&&tabloriaPreuploadSignature===signature)return tabloriaPreuploadPromise;
  tabloriaPreuploadSignature=signature;
  const releaseScroll=tabloriaProtectViewDuringUpload();
  const task=sendCroppedToUploadLift().then(links=>{
    if(cropSignature()===signature&&statusEl&&!addBtn.disabled){
      statusEl.textContent='Fotografiile sunt pregătite. Poți adăuga tabloul în coș.';
    }
    return links;
  }).catch(error=>{
    // Reîncercăm normal când clientul apasă Adaugă în coș.
    console.warn('Tabloria: pregătirea anticipată a fotografiei:',error);
    return null;
  }).finally(()=>setTimeout(releaseScroll,400));
  tabloriaPreuploadPromise=task;
  return task;
}
function tabloriaScheduleCropUpload(){
  clearTimeout(tabloriaPreuploadTimer);
  tabloriaPreuploadTimer=setTimeout(()=>{
    tabloriaPreuploadTimer=null;
    tabloriaPrepareCropUpload();
  },250);
}
async function sendCroppedToUploadLift(){
  const widgets=getWidgetInputs();
  if(!widgets)throw Error('Nu pot identifica sigur cele două câmpuri Upload-Lift. Verifică dacă ambele sunt active și afișate.');
  // Re-sincronizează originalul dacă widgetul s-a montat după transfer.
  const sourceFile=$('file').files?.[0];
  const liftFile=widgets.original.files?.[0];
  if(sourceFile && (!liftFile || liftFile.name!==sourceFile.name || liftFile.size!==sourceFile.size)){
    const originalData=new DataTransfer();originalData.items.add(sourceFile);
    widgets.original.files=originalData.files;
    widgets.original.dispatchEvent(new Event('input',{bubbles:true}));
    widgets.original.dispatchEvent(new Event('change',{bubbles:true}));
  }
  const signature=cropSignature();
  if(tabloriaUploadState.croppedSignature===signature){
    const existing=uploadLinks();
    if(existing?.cropped===tabloriaUploadState.croppedLink)return existing;
  }
  statusEl.textContent='Pregătesc și încarc fotografia încadrată…';
  const {w,h}=dims();
  // Export la aproximativ 25 px/cm, limitat pentru a evita epuizarea memoriei mobile.
  const outW=Math.min(4500,Math.max(1200,Math.round(w*25)));
  const canvas=cropCanvas(outW);
  if(!canvas)throw Error('Fotografia nu este disponibilă.');
  const blob=await new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(Error('Nu pot genera imaginea încadrată.')),'image/jpeg',.93));
  const file=new File([blob],`tabloria-incadrata-${w}x${h}-${Date.now()}.jpg`,{type:'image/jpeg'});
  const dt=new DataTransfer();dt.items.add(file);
  widgets.cropped.files=dt.files;
  widgets.cropped.dispatchEvent(new Event('input',{bubbles:true}));
  widgets.cropped.dispatchEvent(new Event('change',{bubbles:true}));
  const deadline=Date.now()+60000;
  while(Date.now()<deadline){
    const links=uploadLinks();
    const croppedArea=widgetArea(widgets.cropped);
    const displayedName=(croppedArea?.innerText||'').includes(file.name);
    if(links&&displayedName){
      tabloriaUploadState.croppedSignature=signature;
      tabloriaUploadState.croppedLink=links.cropped;
      return links;
    }
    await wait(600);
  }
  throw Error('Upload-Lift nu a confirmat în 60 de secunde imaginea decupată și ambele linkuri. Nu am adăugat produsul în coș.');
}
addBtn.onclick=async()=>{
  if(!shopifyReady)return;
  const [a,b]=sizes[selected],variant=shopifyVariants.get(`${a}x${b}`);
  if(!variant||!variant.available){alert('Varianta selectată nu este disponibilă în Shopify.');return;}
  if(!original){alert('Încarcă fotografia înainte de a continua.');return;}
  addBtn.disabled=true;addBtn.textContent='Se pregătesc fotografiile…';
  try{
    // Dacă utilizatorul apasă imediat după confirmarea încadrării,
    // folosim încărcarea deja începută; altfel aplicăm fluxul sigur existent.
    clearTimeout(tabloriaPreuploadTimer);
    tabloriaPreuploadTimer=null;
    let links=null;
    if(tabloriaPreuploadPromise&&tabloriaPreuploadSignature===cropSignature()){
      links=await tabloriaPreuploadPromise;
    }
    if(!links)links=await sendCroppedToUploadLift();
    const {w,h}=dims();
    const properties={upload:links.original,'Fotografia încadrată':links.cropped,
      'Orientare':landscape?'Orizontal':'Vertical','Dimensiune finală':`${w} × ${h} cm`,
      'Încadrare zoom':Math.round(crop.zoom*100)+'%',
      'Încadrare poziție X':crop.x.toFixed(5),'Încadrare poziție Y':crop.y.toFixed(5),
      'Fotografie originală':$('file').files?.[0]?.name||'',
      '_Tabloria crop JSON':JSON.stringify({version:'15.8.2',zoom:crop.zoom,x:crop.x,y:crop.y,width_cm:w,height_cm:h,original_width_px:original.naturalWidth,original_height_px:original.naturalHeight})};
    statusEl.textContent='Ambele linkuri sunt disponibile. Adaug în coș…';
    const root=window.Shopify?.routes?.root||'/';
    const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity:1,properties}]})});
    const result=await response.json();
    if(!response.ok)throw Error(result.description||result.message||'Eroare la coș');
    const items=Array.isArray(result.items)?result.items:[result];
    if(!items.some(item=>item.properties?.upload===links.original&&item.properties?.['Fotografia încadrată']===links.cropped))throw Error('Shopify nu a confirmat ambele linkuri în răspunsul coșului.');
    location.assign(root+'cart#MainContent');
  }catch(e){statusEl.textContent='Încărcarea nu este confirmată: '+e.message;alert(e.message);}
  finally{addBtn.disabled=false;addBtn.textContent='Adaugă în coș';}
};
loadShopify();








// Încarcă automat originalul în primul câmp Upload-Lift, dacă poate fi identificat.
(function(){
  const source=$('file');if(!source)return;
  source.addEventListener('change',()=>{
    tabloriaUploadState.croppedSignature='';tabloriaUploadState.croppedLink=null;
    const file=source.files?.[0],widgets=getWidgetInputs();
    if(!file||!widgets)return;
    try{const dt=new DataTransfer();dt.items.add(file);widgets.original.files=dt.files;
      widgets.original.dispatchEvent(new Event('input',{bubbles:true}));
      widgets.original.dispatchEvent(new Event('change',{bubbles:true}));
    }catch(e){console.warn('Tabloria: încărcarea originalului necesită verificare manuală',e);}
  });
})();
addBtn.textContent='Adaugă în coș';



/* Tabloria V1.7: preluare locală fotografie și dimensiune din Asistentul perete.
   Nu modifică fluxul Upload-Lift: declanșează evenimentul original al inputului #file. */
(function importFromWallAssistant(){
  const params=new URLSearchParams(location.search);
  const id=params.get('tabloria_transfer');
  if(!id||!/^tb-\d{10,16}-[a-z0-9]{4,16}$/.test(id))return;
  const currentMaterial="canvas";
  function openDB(){return new Promise((resolve,reject)=>{
    if(!window.indexedDB){reject(Error('IndexedDB indisponibil'));return;}
    const q=indexedDB.open('TabloriaAsistentTransfer',1);
    q.onupgradeneeded=()=>{if(!q.result.objectStoreNames.contains('photos'))q.result.createObjectStore('photos');};
    q.onsuccess=()=>resolve(q.result);
    q.onerror=()=>reject(q.error||Error('Nu se poate deschide stocarea locală'));
  });}
  async function retrieve(){
    const db=await openDB();
    return new Promise((resolve,reject)=>{
      const tx=db.transaction('photos','readonly');
      const request=tx.objectStore('photos').get(id);
      request.onsuccess=()=>resolve(request.result);
      request.onerror=()=>reject(request.error);
      tx.oncomplete=()=>db.close();
    });
  }
  async function remove(){
    const db=await openDB();
    return new Promise((resolve)=>{
      const tx=db.transaction('photos','readwrite');tx.objectStore('photos').delete(id);
      tx.oncomplete=()=>{db.close();resolve();};
      tx.onerror=()=>{db.close();resolve();};
    });
  }
  function clearQuery(){
    try{const url=new URL(location.href);url.searchParams.delete('tabloria_transfer');history.replaceState(history.state,'',url.pathname+url.search+url.hash);}catch(e){}
  }
  async function run(){
    try{
      const entry=await retrieve();
      if(!entry||!entry.file||entry.material!==currentMaterial||Date.now()-entry.time>30*60*1000){
        throw Error('Transferul a expirat sau produsul nu corespunde.');
      }
      const pos=sizes.findIndex(s=>`${s[0]}x${s[1]}`===entry.size);
      if(pos<0)throw Error('Dimensiunea selectată nu există în configurator.');
      selected=pos;landscape=false;
      // Selectăm dimensiunea înainte de a declanșa încărcarea fotografiei.
      render();
      const input=$('file');
      if(!input||typeof DataTransfer==='undefined')throw Error('Browserul nu permite preluarea fișierului în configurator.');
      const originalFile=entry.file;
      const file=originalFile instanceof File ? originalFile : new File([originalFile],'tabloria-fotografie.jpg',{type:originalFile.type||'image/jpeg'});
      // Upload-Lift își montează inputurile asincron. Dacă declanșăm change
      // prea devreme, previzualizarea se umple, dar originalul nu e încărcat.
      const deadline=Date.now()+15000;
      while(!getWidgetInputs() && Date.now()<deadline){await wait(250);}
      if(!getWidgetInputs())throw Error('Câmpurile Upload-Lift nu sunt pregătite. Reîncarcă pagina și încearcă din nou.');
      // Lăsăm handlerelor aplicației un ciclu de randare după montare.
      await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
      await wait(450);
      const dt=new DataTransfer();dt.items.add(file);input.files=dt.files;
      input.dispatchEvent(new Event('input',{bubbles:true}));
      input.dispatchEvent(new Event('change',{bubbles:true}));
      // Handlerul existent încarcă poza, deschide popup-ul și alimentează Upload-Lift.
      await remove();clearQuery();
      console.info('Tabloria: fotografia și dimensiunea au fost preluate din asistent.');
    }catch(err){
      console.warn('Tabloria: transferul automat nu a reușit:',err);
      clearQuery();
      const quality=$('quality');
      if(quality)quality.textContent='Transferul automat nu a reușit ('+err.message+'). Încarcă fotografia manual.';
    }
  }
  // Codul este încărcat la finalul fișierului, după inițializarea configuratorului.
  run();
})();
